import React from "react";
import "../../styles/nodatafound.css";

const NoDataFound = () => {
  return (
    <div className="text-center spacing-custom">
      <h5 style={{ fontSize: "1.5rem", marginTop: "2rem" }}>No Data Found</h5>
      {/* Adjusted font size and margin for better mobile display */}
    </div>
  );
};

export default NoDataFound;
